/**
 * Whether this sign-in came from a v1 (existing) customer rather than someone brand new.
 *
 * The UserMigration trigger records the customer's v1 identity in `custom:legacy_sub` when it moves them
 * into the v2 pool. Its presence therefore means exactly one thing: they signed in with credentials that
 * already existed, and their history is waiting to be pulled across.
 *
 * That distinction is the whole point. Both kinds of customer land on the same first-run screen, headed
 * "Set up your account" with an empty form — which to an existing customer of several years reads as
 * having been made to start over, and prompted a run of tickets asking whether their transactions and
 * subscription were gone.
 *
 * Deliberately accepts ANY non-empty value. The trigger originally wrote the customer's EMAIL here rather
 * than their v1 subject id, so some tokens carry one and some the other. Provisioning has to tell them
 * apart, because an email is useless as a key into v1 — but for deciding which words to show, either value
 * proves the same thing.
 */
export function isReturningV1Customer(claims: Record<string, unknown> | undefined): boolean {
  const v = claims?.['custom:legacy_sub'];
  return typeof v === 'string' && v.trim().length > 0;
}
